import { render, staticRenderFns } from "./navigationBlock.vue?vue&type=template&id=6ff7536c&scoped=true"
import script from "./navigationBlock.vue?vue&type=script&lang=js"
export * from "./navigationBlock.vue?vue&type=script&lang=js"
import style0 from "./navigationBlock.vue?vue&type=style&index=0&id=6ff7536c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff7536c",
  null
  
)

export default component.exports